<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('purchaseOrder.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between ts-items-center ts-whitespace-no-wrap ts-space-x-3">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              class="ts-w-64" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <Tooltip :content="$t('purchaseOrder.search')" placement="top" transfer :max-width="width">
              <Input search v-model="search" :placeholder="$t('purchaseOrder.search')" :style="width"
                @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
            </Tooltip>
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter-v2 @filter="branchFilter" class="ts-w-full"></ts-branch-filter-v2>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-md-12">
                  <label class="">{{ $t('purchaseOrder.warehourse') }}</label>
                  <ts-location-filter @filter="filterLocaton"></ts-location-filter>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-md-12">
                  <label>{{ $t('purchaseOrder.vendor') }}</label>
                  <a-select show-search mode="multiple" :placeholder="$t('all')" v-model="vendor_id" showSearch
                    :filterOption="(input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                      " :options="suppliers" class="ts-w-full"></a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe
        max-height="700">
        <template slot-scope="{ row }" slot="branch">
          {{ row.branch ? row.branch.branch_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="amount">
          <ts-display-currency :amount="sumTotalAmount(row.details)" :currency_id="1" />
        </template>
        <template slot-scope="{ row }" slot="supplier">
          {{ row.supplier ? row.supplier.vendor_name : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="create_by">
          {{ row.create_by ? row.create_by.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="is_received">
          <span class="badge badge-success" v-if="row.is_received">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </template>
        <template slot-scope="{ row }" slot="receive_by">
          {{ row.receive_by ? row.receive_by.employee_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a href="#" v-tooltip="$t('dailyCashAdvance.reprint')" class="text-red mr-2"
            @click.prevent="reprintReport(row)">
            <i class="fas fa-file-pdf"></i>
          </a>
          <a v-if="!row.is_received" href="#" v-tooltip="$t('edit')" class="text-primary mr-2"
            @click.prevent="edit(row)">
            <i class="fas fa-edit"></i>
          </a>
          <a-popconfirm v-if="row.stock_in_mains.length == 0" placement="leftTop" :title="$t('are_you_sure_to_delete')"
            :ok-text="$t('yes')" :cancel-text="$t('no')" @confirm="deleteRecord(row)">
            <a href="#" :disabled="row._deleting">
              <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
      </div>
      <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
        <ts-preview-pdf v-model="waiting" :src="src" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import expandRow from './table-expand.vue'

export default {
  name: 'profileIndex',
  data() {
    return {
      loading: false,
      waiting: false,
      show_pdf: false,
      width: 'width: 300px',
      venders: [],
      src: ''
    }
  },
  computed: {
    ...mapState('purchaseOrderV2/order', [
      'resources',
      'pagination',
      'formViewDatas'
    ]),
    search: {
      get() {
        return this.$store.state.purchaseOrderV2.order.search
      },
      set(newValue) {
        this.$store.commit('purchaseOrderV2/order/SET_SEARCH', newValue)
        this.$store.commit('purchaseOrderV2/order/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.purchaseOrderV2.order.dateRange
      },
      set(newValue) {
        this.$store.commit('purchaseOrderV2/order/SET_DATE_RANGE', newValue)
      }
    },
    vendor_id: {
      get() {
        return this.$store.state.purchaseOrderV2.order.vendor_id
      },
      set(newValue) {
        this.$store.commit('purchaseOrderV2/order/SET_VENDOR_ID', newValue)
      }
    },
    suppliers() {
      if (this.formViewDatas['suppliers']) {
        return this.formViewDatas['suppliers'].map(el => ({
          value: el.vendor_id,
          label: el.vendor_name
        }))
      }
      return []
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          },
          width: 30
        },
        {
          title: this.$t('purchaseOrder.poDate'),
          key: 'po_date',
          minWidth: 170,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.branchName'),
          slot: 'branch',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.poNumber'),
          key: 'po_number',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.reference#'),
          key: 'reference_no',
          minWidth: 130,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.amount'),
          slot: 'amount',
          minWidth: 150,
          align: 'right',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('purchaseOrder.vendor'),
          slot: 'supplier',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.createdBy'),
          slot: 'create_by',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.isReceived'),
          slot: 'is_received',
          minWidth: 120,
          align: 'center',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('purchaseOrder.receivedBy'),
          slot: 'receive_by',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.receivedDate'),
          key: 'received_date',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('purchaseOrder.remark'),
          key: 'description',
          minWidth: 200,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          minWidth: 120
        }
      ]
    }
  },
  methods: {
    ...mapActions('purchaseOrderV2/order', ['getFormViewModel']),
    async getPreData() {
      this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'suppliers'
        }
      }).catch(error => {
        this.notice({ type: 'error', text: error.message })
      })
    },
    branchFilter(value) {
      this.$store.commit('purchaseOrderV2/order/SET_BRANCH_ID', value)
      this.fetchData()
    },
    filterLocaton(value) {
      this.$store.commit('purchaseOrderV2/order/SET_LOCATION_ID', value)
      this.fetchData()
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('purchaseOrderV2/order/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'purchase-order-create-v2' })
    },
    edit(record) {
      this.$router.push({
        name: 'purchase-order-edit-v2',
        params: { id: record.po_id }
      })
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('purchaseOrderV2/order/destroy', record.po_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    reprintReport(record) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('purchaseOrderV2/order/printPdf', record.po_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    sumTotalAmount(details = []) {
      return _.sumBy(details, 'total_after_discount')
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    vendor_id: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.getPreData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrderV2/order/RESET_STATE')
    next()
  }
}
</script>
<style>
.ivu-input-with-suffix {
  height: 34px !important;
}
</style>
